module.exports = __webpack_public_path__ + "static/img/19034103295190235.32713499.jpg";